import React from 'react';
import type { FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { classNames } from '../utils/classNames';

type Props<T extends FieldValues> = {
  isRequired?: boolean,
  form?: Pick<UseFormReturn<T>, 'register'>,
  name: Path<T>,
  label?: string,
  value?: React.InputHTMLAttributes<HTMLInputElement>['value'],
  labelExtraClassName?: string,
  className?: string,
  disabled?: boolean,
  readonly?: boolean,
  checked?: boolean,
  indeterminate?: boolean,
  onClick?: React.MouseEventHandler<HTMLInputElement>,
  onChange?: React.ChangeEventHandler<HTMLInputElement>,
};

function FormCheckbox<T extends FieldValues = FieldValues>({
  isRequired, form, name, label, className, labelExtraClassName, value,
  disabled, readonly, checked, indeterminate = false, onClick, onChange,
}: Props<T>) {
  const uniqueId = React.useId();
  const registration = form?.register(name, { required: isRequired });
  return <div className="flex items-center">
    <input
      {...registration}
      id={uniqueId}
      name={name}
      ref={element => {
        registration?.ref(element);
        if (element !== null) element.indeterminate = indeterminate;
      }}
      type="checkbox"
      value={value}
      checked={checked}
      aria-checked={indeterminate ? 'mixed' : checked}
      readOnly={readonly}
      disabled={disabled}
      onClick={onClick}
      onChange={event => {
        void registration?.onChange(event);
        onChange?.(event);
      }}
      className={classNames(className ?? 'input-checkbox')}
    />
    <label htmlFor={uniqueId} className={classNames('ml-2 label', labelExtraClassName ?? '-')}>
      {label}
    </label>
  </div>;
}

export default FormCheckbox;
